import { ContentContainer } from "components/Container";
import { useTranslation } from "react-i18next";

const features = [
  { titleKey: "accessibility.dark_title", textKey: "accessibility.dark_text" },
  { titleKey: "accessibility.scale_title", textKey: "accessibility.scale_text" },
  {
    titleKey: "accessibility.contrast_title",
    textKey: "accessibility.contrast_text",
  },
];

export const Accessibility = () => {
  const { t } = useTranslation();

  return (
    <section id="accessibility" className="mt-20 lg:mt-36 scroll-mt-10">
      <ContentContainer>
        <h2 className="max-w-78 md:max-w-full title-text-style">
          {t("accessibility.title")}
        </h2>
        <p className="subtitle-text-style max-w-812px mt-5 lg:mt-6">
          {t("accessibility.subtitle")}
        </p>
        <div className="mt-10 lg:mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {features.map((feature) => (
            <div key={feature.titleKey}>
              <h3 className="text-2xl font-semibold text-textPrimary">
                {t(feature.titleKey)}
              </h3>
              <p className="text-textSecondaryGrey text-base mt-3">
                {t(feature.textKey)}
              </p>
            </div>
          ))}
        </div>
      </ContentContainer>
    </section>
  );
};
